var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var DoRequest = /** @class */ (function () {
    function DoRequest(baseRequest) {
        this.baseRequest = baseRequest;
    }
    DoRequest.prototype.apiAddresses = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.baseRequest.doRequest('Api Addresses', request)];
            });
        });
    };
    DoRequest.prototype.abonDiag = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.baseRequest.doRequest('Abon diag', request)];
            });
        });
    };
    DoRequest.prototype.apiAuth = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.baseRequest.doRequest('API Auth', request)];
            });
        });
    };
    DoRequest.prototype.apiB2cDomru = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.baseRequest.doRequest('Api B2C-domru', request)];
            });
        });
    };
    DoRequest.prototype.apiContent = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.baseRequest.doRequest('API Content', request)];
            });
        });
    };
    DoRequest.prototype.apiContentStatic = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.baseRequest.doRequest('API Content Static', request)];
            });
        });
    };
    DoRequest.prototype.apiEsign = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.baseRequest.doRequest('Api Esign', request)];
            });
        });
    };
    DoRequest.prototype.apiEPG = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.baseRequest.doRequest('API EPG', request)];
            });
        });
    };
    DoRequest.prototype.apiGames = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.baseRequest.doRequest('Api Games', request)];
            });
        });
    };
    DoRequest.prototype.apiLoyalty = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.baseRequest.doRequest('API Loyalty', request)];
            });
        });
    };
    DoRequest.prototype.apiPay = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.baseRequest.doRequest('API Pay', request)];
            });
        });
    };
    DoRequest.prototype.apiProfile = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.baseRequest.doRequest('API Profile', request)];
            });
        });
    };
    DoRequest.prototype.apiRequest = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.baseRequest.doRequest('API Request', request)];
            });
        });
    };
    DoRequest.prototype.apiRouterControl = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.baseRequest.doRequest('Api Router Control', request)];
            });
        });
    };
    DoRequest.prototype.apiSeasonTicket = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.baseRequest.doRequest('Api Season ticket', request)];
            });
        });
    };
    DoRequest.prototype.apiTariffs = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.baseRequest.doRequest('Api Tariffs', request)];
            });
        });
    };
    DoRequest.prototype.apiVas = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.baseRequest.doRequest('Api Vas', request)];
            });
        });
    };
    DoRequest.prototype.apiWidgets = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.baseRequest.doRequest('Api Widgets', request)];
            });
        });
    };
    DoRequest.prototype.coreRequests = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.baseRequest.doRequest('Core Requests', request)];
            });
        });
    };
    DoRequest.prototype.dadataProxy = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.baseRequest.doRequest('Dadata', request)];
            });
        });
    };
    DoRequest.prototype.fullBuy = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.baseRequest.doRequest('Api Full Buy', request)];
            });
        });
    };
    DoRequest.prototype.gamersBase = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.baseRequest.doRequest('Gamers Base', request)];
            });
        });
    };
    DoRequest.prototype.genesysProxy = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.baseRequest.doRequest('Genesys proxy', request)];
            });
        });
    };
    DoRequest.prototype.multiscreen = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.baseRequest.doRequest('Multiscreen', request)];
            });
        });
    };
    DoRequest.prototype.payments = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.baseRequest.doRequest('Payments', request)];
            });
        });
    };
    DoRequest.prototype.phoneValidator = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.baseRequest.doRequest('Phone validator', request)];
            });
        });
    };
    DoRequest.prototype.ppdService = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.baseRequest.doRequest('PPD service', request)];
            });
        });
    };
    DoRequest.prototype.r1PlatformGateway = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.baseRequest.doRequest('R1 Platform Gateway', request)];
            });
        });
    };
    DoRequest.prototype.specOffer = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.baseRequest.doRequest('API Spec Offer', request)];
            });
        });
    };
    DoRequest.prototype.yandexSearchProxy = function (request) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.baseRequest.doRequest('Yandex search proxy', request)];
            });
        });
    };
    return DoRequest;
}());
export { DoRequest };
